/**
 * @generated SignedSource<<323f6f2ee0c5871823c0ee24d3d54fdd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaceholderBulkCreateInput = {
  placeholders: ReadonlyArray<PlaceholderBulkCreate>;
};
export type PlaceholderBulkCreate = {
  competencies?: ReadonlyArray<PersonCompetencies> | null | undefined;
  cost?: number | null | undefined;
  custom_values?: PersonInputCustomValues | null | undefined;
  first_name?: string | null | undefined;
  last_name?: string | null | undefined;
  role_id: number;
  tags?: ReadonlyArray<string | null | undefined> | null | undefined;
  team_id?: number | null | undefined;
};
export type PersonCompetencies = {
  level?: number | null | undefined;
  skill: PersonSkill;
};
export type PersonSkill = {
  name: string;
};
export type PersonInputCustomValues = {
  checkbox?: ReadonlyArray<PersonInputCustomValuesCheckbox | null | undefined> | null | undefined;
  date?: ReadonlyArray<PersonInputCustomValuesDate | null | undefined> | null | undefined;
  select?: ReadonlyArray<PersonInputCustomValuesSelect | null | undefined> | null | undefined;
  text?: ReadonlyArray<PersonInputCustomValuesText | null | undefined> | null | undefined;
};
export type PersonInputCustomValuesCheckbox = {
  typeId: number;
  value: boolean;
};
export type PersonInputCustomValuesDate = {
  typeId: number;
  value?: string | null | undefined;
};
export type PersonInputCustomValuesSelect = {
  optionId: number;
  typeId: number;
};
export type PersonInputCustomValuesText = {
  typeId: number;
  value: string;
};
export type PlaceholderBulkCreateMutation$variables = {
  input: PlaceholderBulkCreateInput;
  plannerStartDate: any;
};
export type PlaceholderBulkCreateMutation$data = {
  readonly action_placeholder_bulk_create: ReadonlyArray<{
    readonly account: {
      readonly id: number;
      readonly roles: ReadonlyArray<{
        readonly active: boolean;
        readonly contracts: ReadonlyArray<{
          readonly person: {
            readonly created_at: string;
            readonly first_name: string;
            readonly last_name: string;
            readonly placeholder_count: number;
          };
        }>;
        readonly default_hour_cost: number | null | undefined;
        readonly id: number;
        readonly name: string;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"TeamSelector_account">;
    } | null | undefined;
    readonly person: {
      readonly account_id: number;
      readonly active: boolean;
      readonly assignments: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly is_billable: boolean | null | undefined;
        readonly is_template: boolean;
        readonly minutes_per_day: number;
        readonly non_working_day: boolean;
        readonly note: string | null | undefined;
        readonly person_id: number;
        readonly phase_id: number | null | undefined;
        readonly project: {
          readonly team_id: number | null | undefined;
        };
        readonly project_id: number;
        readonly role_id: number;
        readonly start_date: string | null | undefined;
        readonly workstream_id: number | null | undefined;
      }>;
      readonly competencies: ReadonlyArray<{
        readonly id: number;
        readonly level: number | null | undefined;
        readonly skill: {
          readonly id: number;
          readonly name: string;
        };
        readonly skill_id: number;
      }>;
      readonly contracts: ReadonlyArray<{
        readonly cost: number | null | undefined;
        readonly employment_type: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly minutes_per_day: number | null | undefined;
        readonly role: {
          readonly id: number;
          readonly name: string;
        };
        readonly role_id: number;
        readonly start_date: string | null | undefined;
      }>;
      readonly created_at: string;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly email: string | null | undefined;
      readonly first_name: string;
      readonly id: number;
      readonly image_key: string | null | undefined;
      readonly is_placeholder: boolean;
      readonly last_name: string;
      readonly links: ReadonlyArray<{
        readonly href: string;
        readonly id: number;
        readonly name: string;
        readonly show_in_planner: boolean;
      }>;
      readonly managers: ReadonlyArray<{
        readonly id: number;
        readonly user_id: number;
      }>;
      readonly people_notes: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly person_requests: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly placeholder_count: number;
      readonly placeholder_suggestions: ReadonlyArray<{
        readonly suggested_person: {
          readonly id: number;
          readonly " $fragmentSpreads": FragmentRefs<"SuggestedPerson_person">;
        };
        readonly suggested_person_id: number;
      }>;
      readonly project_memberships: ReadonlyArray<{
        readonly id: number;
        readonly is_placeholder: boolean;
        readonly project: {
          readonly id: number;
          readonly name: string;
        };
      }>;
      readonly references: any;
      readonly tags: any;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly time_offs: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly ext_time_off_links: ReadonlyArray<{
          readonly active: boolean;
          readonly ext_time_off_id: number;
          readonly external: {
            readonly __typename: "ext_time_off";
            readonly id: number;
            readonly integration_id: number;
          } | null | undefined;
          readonly external_id: number;
          readonly time_off_id: number;
        }>;
        readonly id: number;
        readonly leave_type: string;
        readonly minutes_per_day: number | null | undefined;
        readonly person_id: number;
        readonly start_date: string | null | undefined;
      }>;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type PlaceholderBulkCreateMutation = {
  response: PlaceholderBulkCreateMutation$data;
  variables: PlaceholderBulkCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plannerStartDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_placeholder",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image_key",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeholder_count",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  (v2/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v19 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role_id",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "contracts",
  "kind": "LinkedField",
  "name": "contracts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    {
      "alias": "cost",
      "args": null,
      "kind": "ScalarField",
      "name": "cost_private",
      "storageKey": null
    },
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employment_type",
      "storageKey": null
    },
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "roles",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "_gte",
            "variableName": "plannerStartDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "end_date_iso"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "person_id",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": (v23/*: any*/),
  "concreteType": "assignments",
  "kind": "LinkedField",
  "name": "assignments",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_billable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "is_template",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "project_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v10/*: any*/)
      ],
      "storageKey": null
    },
    (v24/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workstream_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "non_working_day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "_eq": true
},
v27 = {
  "alias": null,
  "args": (v23/*: any*/),
  "concreteType": "time_offs",
  "kind": "LinkedField",
  "name": "time_offs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leave_type",
      "storageKey": null
    },
    (v20/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "active": (v26/*: any*/)
          }
        }
      ],
      "concreteType": "ext_time_off_link",
      "kind": "LinkedField",
      "name": "ext_time_off_links",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time_off_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ext_time_off_id",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": "external_id",
          "args": null,
          "kind": "ScalarField",
          "name": "ext_time_off_id",
          "storageKey": null
        },
        {
          "alias": "external",
          "args": null,
          "concreteType": "ext_time_off",
          "kind": "LinkedField",
          "name": "ext_time_off",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integration_id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "ext_time_off_links(where:{\"active\":{\"_eq\":true}})"
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "competencies",
  "kind": "LinkedField",
  "name": "competencies",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skill_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "skills",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v29 = [
  (v2/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "people_notes",
  "kind": "LinkedField",
  "name": "people_notes",
  "plural": true,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "person_requests",
  "kind": "LinkedField",
  "name": "person_requests",
  "plural": true,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "project_members",
  "kind": "LinkedField",
  "name": "project_memberships",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "projects",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggested_person_id",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "people_links",
  "kind": "LinkedField",
  "name": "links",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "show_in_planner",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "people_managers",
  "kind": "LinkedField",
  "name": "managers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "user_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "roles",
  "kind": "LinkedField",
  "name": "roles",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v15/*: any*/),
    (v3/*: any*/),
    {
      "alias": "default_hour_cost",
      "args": null,
      "kind": "ScalarField",
      "name": "default_hour_cost_private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "order_by",
          "value": {
            "created_at": "desc"
          }
        },
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "person": {
              "is_placeholder": (v26/*: any*/)
            }
          }
        }
      ],
      "concreteType": "contracts",
      "kind": "LinkedField",
      "name": "contracts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "people",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "contracts(limit:1,order_by:{\"created_at\":\"desc\"},where:{\"person\":{\"is_placeholder\":{\"_eq\":true}}})"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlaceholderBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlaceholderBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_placeholder_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v22/*: any*/),
              (v25/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "placeholder_suggestions",
                "kind": "LinkedField",
                "name": "placeholder_suggestions",
                "plural": true,
                "selections": [
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "suggested_person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedPerson_person"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v41/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSelector_account"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaceholderBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PlaceholderBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_placeholder_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              (v22/*: any*/),
              (v25/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "placeholder_suggestions",
                "kind": "LinkedField",
                "name": "placeholder_suggestions",
                "plural": true,
                "selections": [
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "suggested_person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dcf6faea108f9a9ac753750a9527049f",
    "id": null,
    "metadata": {},
    "name": "PlaceholderBulkCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PlaceholderBulkCreateMutation(\n  $input: PlaceholderBulkCreateInput!\n  $plannerStartDate: date!\n) {\n  action_placeholder_bulk_create(input: $input) {\n    person {\n      id\n      active\n      first_name\n      last_name\n      email\n      is_placeholder\n      account_id\n      tags\n      team_id\n      references\n      image_key\n      placeholder_count\n      created_at\n      team {\n        id\n        name\n      }\n      contracts {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        cost: cost_private\n        minutes_per_day\n        employment_type\n        role_id\n        role {\n          id\n          name\n        }\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        minutes_per_day\n        is_billable\n        is_template\n        project_id\n        project {\n          team_id\n        }\n        person_id\n        role_id\n        phase_id\n        workstream_id\n        non_working_day\n        note\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        person_id\n        leave_type\n        minutes_per_day\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      competencies {\n        id\n        level\n        skill_id\n        skill {\n          name\n          id\n        }\n      }\n      people_notes {\n        id\n      }\n      person_requests {\n        id\n      }\n      project_memberships {\n        id\n        is_placeholder\n        project {\n          id\n          name\n        }\n      }\n      placeholder_suggestions {\n        suggested_person_id\n        suggested_person {\n          id\n          ...SuggestedPerson_person\n        }\n      }\n      links {\n        id\n        name\n        href\n        show_in_planner\n      }\n      managers {\n        id\n        user_id\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n    }\n    account {\n      id\n      roles {\n        id\n        name\n        active\n        default_hour_cost: default_hour_cost_private\n        contracts(where: {person: {is_placeholder: {_eq: true}}}, limit: 1, order_by: {created_at: desc}) {\n          person {\n            first_name\n            last_name\n            placeholder_count\n            created_at\n          }\n        }\n      }\n      ...TeamSelector_account\n    }\n  }\n}\n\nfragment SuggestedPerson_person on people {\n  first_name\n  last_name\n  image_key\n}\n\nfragment TeamSelector_account on accounts {\n  teams {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "c47eae51be8ee8f41408c3c9b49641af";

export default node;
